export class SpineFile {
  constructor({
    name,
    fileName,
    path,
  }) {
    this.name = name;
    this.path = `${path}/${fileName}.json`;
    this.config = {
      metadata: {
        spineAtlasFile: `${path}/${fileName}.atlas`,
      },
    };
  }
}
